module.exports = __webpack_public_path__ + "img/car1.d3500f84.png";